import { FC } from "react";
import defaultPlaceholder from "../../public/favicon.png";

interface ImageWithPlaceholderProps {
    src: string;
    alt: string;
    className: string;
}

const ImageWithPlaceholder: FC<ImageWithPlaceholderProps> = ({ src, alt, className }) => {
  return (
    <img
      className={className}
      src={src}
      alt={alt}
      style={{opacity: '100%'}}
      loading="lazy" //Images that are not visible immediately are only loaded when the user scrolls to them. Big performance boost for pages with lots of images.
      decoding="async"
       onError={(e) => {
        e.currentTarget.src = defaultPlaceholder; 
        e.currentTarget.style.opacity = "10%";
    }}
      
    />
  );
};

export default ImageWithPlaceholder;
